import { Search, X } from 'lucide-react'
import { cn } from '@/lib/utils'

interface SearchInputProps {
  placeholder?: string
  value?: string
  onChange?: (value: string) => void
  className?: string
}

export function SearchInput({
  placeholder = 'Buscar...',
  value,
  onChange,
  className,
}: SearchInputProps) {
  return (
    <div className={cn('relative w-full md:w-[320px] shrink-0', className)}>
      <Search
        size={16}
        className="absolute left-3 top-1/2 -translate-y-1/2 text-fg-quaternary pointer-events-none"
      />
      <input
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange?.(e.target.value)}
        className={cn(
          'w-full h-10 pl-9 pr-9 rounded-full',
          'border border-border-secondary bg-bg-primary text-sm text-text-primary',
          'placeholder:text-text-placeholder',
          'focus:border-border-brand focus:outline-none focus:ring-1 focus:ring-brand-600/20',
          'transition-all duration-150',
        )}
      />
      {value && (
        <button
          type="button"
          onClick={() => onChange?.('')}
          className="absolute right-3 top-1/2 -translate-y-1/2 text-fg-quaternary hover:text-fg-primary transition-colors"
        >
          <X size={14} />
        </button>
      )}
    </div>
  )
}
